export type RecordType = Record<string, string | number | boolean>;

export interface TimeZone {
  zone: string;
  name: string;
  gmtOffset: string;
  utcOffset: string;
}

export type LanguagesCode =
  | 'en-AU'
  | 'en-BE'
  | 'en-GB'
  | 'en-JP'
  | 'en-US'
  | 'en-ZA'
  | 'en-NZ';

export interface Language {
  code: LanguagesCode;
  name: string;
  countryCode: string;
}

export enum Gender {
  male = 'M',
  female = 'F',
  other = 'UN',
  unknown='UNK'
}